import './DataItem.scss';
import { Badge, Divider, Typography } from 'antd';
import { colors } from '../../../theme/colors';
import { useTranslation } from '../../../i18n/i18n';

const { Text } = Typography;

interface DataItemProps {
  title: string;
  data: string;
  extra?: string;
  status?: boolean;
  statusColor?: string;
  waterHarvesting?: boolean;
}
const DataItem = ({ title, data, extra, status, statusColor, waterHarvesting }: DataItemProps) => {
  const { t } = useTranslation('installation-location', { keyPrefix: 'installationLocationDetail' });
  return (
    <div className={'DataItem'}>
      <div className={'DataItem__info'}>
        <Text>{title}</Text>
        {waterHarvesting === undefined ? (
          <div className={'DataItem__info__multipleData'}>
            {status && <Badge dot style={{ backgroundColor: statusColor || colors.COLOR_TEXT_COMPONENTS }}></Badge>}
            <Text className={'DataItem__info__data'}>{data}</Text>
            {extra && <Text className={'DataItem__info__data__extra'}>{extra}</Text>}
          </div>
        ) : waterHarvesting ? (
          <div className={'DataItem__info__waterHarvesting'}>
            <Badge dot style={{ backgroundColor: colors.GREEN }} className={'DataItem__info__data__yes'}></Badge>
            <Text className={'DataItem__info__data__yes'}>{t('yes')}</Text>
          </div>
        ) : (
          <div className={'DataItem__info__waterHarvesting'}>
            <Badge dot style={{ backgroundColor: colors.RED }} className={'DataItem__info__data__no'}></Badge>
            <Text className={'DataItem__info__data__no'}>{t('no')}</Text>
          </div>
        )}
      </div>
      <Divider className={'DataItem__divider'} />
    </div>
  );
};

export default DataItem;
